var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarbonCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4688 32.2502L5.375 20.1564L7.27506 18.2563L17.4688 28.4487L35.7249 10.1938L37.625 12.0939L17.4688 32.2502Z",
    fill: "#222A27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonCheckmark);
export default __webpack_public_path__ + "static/media/carbon_checkmark.cd9bd82442af1e95546018ce84cb1a2c.svg";
export { ForwardRef as ReactComponent };